<template></template>
<script>
  export default {
    methods: {
      logout() {
        this.$store.dispatch('Auth/logout');
      }
    },
    beforeMount() {
      this.logout();
    }
  };
</script>